import { createAuth0 } from "@auth0/auth0-vue";

export const auth0 = createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    // Falls back to the current origin so dev servers on other ports/hosts
    // (worktree ports, Tailscale device testing) authenticate without a
    // per-origin env change. Prod always sets VITE_AUTH0_CALLBACK_URL.
    redirect_uri:
      import.meta.env.VITE_AUTH0_CALLBACK_URL ||
      `${window.location.origin}/callback`,
  },
  // Use localStorage instead of in-memory storage to fix Safari ITP issues.
  // Safari's Intelligent Tracking Prevention can clear session/memory storage
  // during the Auth0 redirect flow, causing "Invalid state" errors on callback.
  cacheLocation: "localstorage",
  // Enable refresh tokens for more reliable session management across all browsers.
  // Requires "Refresh Token Rotation" to be enabled in Auth0 Dashboard.
  useRefreshTokens: true,

  // NOTE: @auth0/auth0-vue 2.x has no `onRedirectCallback` plugin option —
  // the SDK internally handles the redirect callback and router.push()es to
  // appState?.target || "/" on its own. A dead option that claimed to do
  // this was removed 2026-07-21 (behavior unchanged; verified against the
  // installed bundle).
});

/**
 * Clear stale Auth0 cache from localStorage.
 * Called when "Missing Refresh Token" error occurs due to cached auth state
 * from before Refresh Token Rotation was enabled.
 */
export function clearAuth0Cache() {
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith("@@auth0spajs@@")) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
  console.log(`[Auth0] Cleared ${keysToRemove.length} stale cache entries`);
}
